import {
  watchInitializeAssignmentReview,
} from './canvasAssignmentReviewSagas';
import {
  watchFetchCollectionsRequest,
} from './collectionsSagas';
import {
  watchGetContent
} from './contentSagas';
import {
  watchFetchEmails,
  watchMakeEmailPrimary,
  watchCreateNewEmail,
} from './emailsSagas';
import {
  watchFetchEventRecords,
  watchCreateEventRecord,
} from './eventRecordSagas';
import {
  watchClearExternalToolContext,
  watchSetExternalToolContext,
  watchGetExternalToolContext,
} from './externalToolSagas';
import {
  watchGetLessonSpark
} from './lessonSparksSagas';
import {
  watchGetLikedContent,
  watchCreateLikedContent,
  watchDeleteLikedContent,
} from './likedContentSagas';
import {
  watchInitializeYourContentPage,
  watchBookmarkedArticleHeadersFetchRequest,
  watchTextSetsFetchRequest,
  watchBookmarkedStandardsFetchRequest,
} from './yourContentPageSagas';


export default [
  watchFetchEmails,
  watchMakeEmailPrimary,
  watchCreateNewEmail,

  watchGetContent,

  watchGetLikedContent,
  watchCreateLikedContent,
  watchDeleteLikedContent,

  watchGetLessonSpark,

  watchClearExternalToolContext,
  watchSetExternalToolContext,
  watchGetExternalToolContext,
  watchInitializeAssignmentReview,

  watchFetchEventRecords,
  watchCreateEventRecord,

  watchFetchCollectionsRequest,

  watchInitializeYourContentPage,
  watchBookmarkedArticleHeadersFetchRequest,
  watchTextSetsFetchRequest,
  watchBookmarkedStandardsFetchRequest,
];
